"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertNullToUndefined = convertNullToUndefined;
exports.convertStringDatesToDateObjects = convertStringDatesToDateObjects;
exports.preprocessNote = preprocessNote;
exports.preprocessResult = preprocessResult;
function convertNullToUndefined(...fields) {
    return (obj) => {
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }
        const result = { ...obj };
        for (const field of fields) {
            if (field in result && result[field] === null) {
                result[field] = undefined;
            }
        }
        return result;
    };
}
function convertStringDatesToDateObjects(...fields) {
    return (obj) => {
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }
        const result = { ...obj };
        for (const field of fields) {
            const value = result[field];
            if (field in result && typeof value === 'string') {
                result[field] = new Date(value);
            }
        }
        return result;
    };
}
function preprocessNote(note) {
    const withNullConverted = convertNullToUndefined('statusOverride')(note);
    return convertStringDatesToDateObjects('createdAt', 'updatedAt')(withNullConverted);
}
function preprocessResult(result) {
    if (typeof result !== 'object' || result === null) {
        return result;
    }
    const withNullConverted = convertNullToUndefined('statusOverride')(result);
    if (Array.isArray(withNullConverted.notes)) {
        withNullConverted.notes = withNullConverted.notes.map(preprocessNote);
    }
    return withNullConverted;
}
//# sourceMappingURL=zod-preprocessors.js.map